<template>
    <div v-if="prod.pictures">
        <div v-for="(item, index) in prod.pictures"
            :key="item"
        >
            <img v-if="index === 0"
                :src=" define.prevFolder + item "
                alt="">
        </div>
    </div>
    <img v-else
        :src=" define.pathToGraphics + '/default2_190px.png' "
        alt="">
    <h5 class="mb-4px">{{ prod.brand }}</h5>
    <h5>{{ prod.model }}</h5>
    {{ insert.price }}: {{ prod.price }} USD
</template>

<script>
import { define } from '@/data/globals.js'

export default {
    props: {
        prod: {
            type: Object,
            required: true
        },
        insert: {
            type: Object,
            required: true
        },
    },

    setup() {
        return { define }
    }
}
</script>

<style>
</style>